export const Role = Object.freeze({
  ADMIN: 'admin',
  CREATOR: 'creator',
  EDITOR: 'editor',
  VISITOR: 'visitor'
})
